import React from 'react';
import Box from '@mui/material/Box';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { MAX_GRID_WIDTH } from 'bento-ordering/base/constants/maxWidth';

const GridContainer = ({ children, ...props }) => (
  <Box {...props} maxWidth={MAX_GRID_WIDTH} margin="0 auto" width="100%">
    {children}
  </Box>
);

GridContainer.propTypes = {
  children: CHILDREN_PROP_TYPES
};

export default GridContainer;
